/* global d3 */
import DrawExploration from './drawExploration.js'
import pipeService from '../../service/pipeService'

export default {
    name: 'ExplorationView',
    components: {},
    props: {
        videoId: String,
        videoData: Object,
        featureThs: Object,
    },
    data() {
        return {
            containerId: 'explorationContainer',
            storyviewdata: {},
            explorationviewdata: {},
        }
    },
    watch: {
        featureThs: function(){
            console.log("i am here (Exploration view):  feature thresholds")
            this.drawExploration.layout(this.explorationviewdata, this.storyviewdata, this.featureThs);
        },
    },
    mounted: function() {
        const _this = this;
        _this.drawExploration = new DrawExploration(_this.containerId);/* eslint-disable-line */
        console.log("sending thresholds to explorationview", _this.drawExploration);/* eslint-disable-line */
        pipeService.onSelectVideo(selected=>{
            console.log("seleted: in exploration view: ", selected);
            d3.json(window.location.href + "data/"+selected+".json").then((explorationviewdata) => {
                d3.json(window.location.href + "data/" + selected +"_laughter.json").then((storyviewdata) => {
                    _this.explorationviewdata = explorationviewdata;
                    _this.storyviewdata = storyviewdata;
                    _this.drawExploration.layout(_this.explorationviewdata, _this.storyviewdata, _this.featureThs);
                });
                
            });
        });

    }
}